"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.stats.total': '总入职数',
    'onboarding.stats.in_progress': '进行中',
    'onboarding.stats.completed': '已完成',
    'onboarding.stats.avatars_created': '已创建头像',
};
